export function formatLongDate(dateString: string): string {
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };

  const date = new Date(dateString);
  const formattedDate = date.toLocaleString('en-US', options);
  const dayOrdinal = getDayOrdinal(date.getDate());

  return formattedDate.replace(/\b(\d{1,2})\b/, `$1${dayOrdinal}`);
}

export function getDayOrdinal(day: number): 'st' | 'nd' | 'rd' | 'th' {
  const SINGLE_DIGIT_MODULO = 10;
  const DOUBLE_DIGIT_MODULO = 100;
  const THRESHOLD_START = 11;
  const THRESHOLD_END = 13;
  const FIRST_ORDINAL = 'st';
  const SECOND_ORDINAL = 'nd';
  const THIRD_ORDINAL = 'rd';
  const DEFAULT_ORDINAL = 'th';
  const FIRST_DIGIT_ONE = 1;
  const FIRST_DIGIT_TWO = 2;
  const FIRST_DIGIT_THREE = 3;
  const firstDigit = day % SINGLE_DIGIT_MODULO;
  const secondDigit = day % DOUBLE_DIGIT_MODULO;

  if (secondDigit >= THRESHOLD_START && secondDigit <= THRESHOLD_END) {
    return DEFAULT_ORDINAL;
  }

  switch (firstDigit) {
    case FIRST_DIGIT_ONE:
      return FIRST_ORDINAL;
    case FIRST_DIGIT_TWO:
      return SECOND_ORDINAL;
    case FIRST_DIGIT_THREE:
      return THIRD_ORDINAL;
    default:
      return DEFAULT_ORDINAL;
  }
}
